import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {withTranslation} from 'react-i18next'
import history from '../../../routes/history'

@inject('marketingSmsManagementStore', 'marketingSmsTemplateStore', 'accountStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }
  componentDidMount() {
  }
  handleUse = (record) => {
    const {marketingSmsManagementStore, onChangeInsertModel, handleCancel, t} = this.props
    marketingSmsManagementStore.onChangeTemplateObj(record)
    onChangeInsertModel(record?.template)
    handleCancel()
  }
  handlePageChange = (page, pageSize) => {
    const {marketingSmsTemplateStore} = this.props
    marketingSmsTemplateStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  createModel = () => {
    const {accountStore} = this.props
      history.push(`/smsTemplate`)
      accountStore.setSeletedItem('smsTemplate')
      accountStore.onMenuClick(['smsTemplate'])
    }
  render() {
    const {marketingSmsTemplateStore, type, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, signList} = marketingSmsTemplateStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} style={{marginTop: 0, paddingTop: 0}}>
          <Table.Column title={t(`marketingManagement.modelId`)} dataIndex="id" key="id" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.modelName`)} dataIndex="templateName" key="templateName" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.content`)} dataIndex="template" key="template" ellipsis={true} render={(text, record) => 
            type ==='1' ? `${signList?.find(a=>a?.id===record?.signId)?.sign} ${text} ${record?.templateSuffix}` : `${signList?.find(a=>a?.id===record?.signId)?.sign} ${text}`
          } />
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleUse(record)}title={t(`general.use`)}>{t(`general.use`)}</Button>
            </>
          )} />
        </Table>
        {toJS(jobList).length>0 ? null : <div style={{textAlign: 'center', marginTop: 10}}>
          前往创建<Button type='link' onClick={this.createModel}>{t(`marketingManagement.modelList`)}</Button>
        </div>}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
